declare module 'react-swipeable';
